import actionCreatorFactory from 'typescript-fsa';
import { IApps } from 'ui/utils/appsList';

const actionCreator = actionCreatorFactory('PATIENTSIDEBAR/SIDEBAR');

const actions = {
  setCurrentApp: actionCreator<{ appName: IApps['name'] }>('setCurrentApp'),
  toggleSidebar: actionCreator('toggleSidebar'),
  setSidebarState: actionCreator<{ set: 'open' | 'close' }>('setSidebarState'),
  incrementAppsClickCount: actionCreator('incrementAppsClickCount'),
  resetSidebar: actionCreator('RESET'),
};

const thunks = {};

export default { ...actions, ...thunks };
